import { QuestionAutocompleteInput, QuestionMultiselectInput, QuestionSelectInput, QuestionTextInput } from "../../Component";
import { useApp } from "../../Contexts/AppProvider";
import { IQuestion, IQuestionOptions } from "../../interfaces";
import { useFormContext } from "react-hook-form";

export default function RenderQuestion(props: IQuestion, i: number) {
  const {estados, cidades, bairros, onGetCidades, onGetBairros} = useApp();
  const {getValues} = useFormContext();

  if (props?.type === 'estados') {
    const estadosFormatted = estados?.list?.map((estado): IQuestionOptions => {
      return {value: estado.nome};
    }); 

    const newProps = {
      ...props,
      options: estadosFormatted,
      selectProps: {
        disabled: estados?.loading,
        placeholder: estados?.loading ? 'Carregando...' : 'Selecione ou digite o nome para buscar',
        onChange: (_: React.SyntheticEvent<Element, Event>, newValue: any) => {
          const estadoObj = estados?.list?.find((estado) => newValue === estado?.nome);
          onGetCidades(estadoObj?.id as number);
        }
      }
    }

    return <QuestionAutocompleteInput key={`${i}-select-estado`}  {...newProps} />;
  } else 
  if (props?.type === 'cidades') {
    const cidadesFormatted = cidades?.list?.map((cidade): IQuestionOptions => {
      return {value: cidade.nome};
    });

    const newProps = {
      ...props, 
      options: cidadesFormatted,
      selectProps: {
        disabled: cidades?.loading || cidades?.list?.length === 0,
        onChange: (_: React.SyntheticEvent<Element, Event>, newValue: any) => {
          const uf = estados?.list?.find(e => e?.nome === getValues()['13'])?.sigla;
          onGetBairros(uf as string, newValue as string, getValues()['9'] === '-1' ? 'Rua' : getValues()['9']);
        },
        placeholder: cidades?.loading 
          ? 'Carregando...' 
          : cidades?.list?.length === 0 
            ? 'Selecione um estado primeiro' 
            : 'Selecione ou digite o nome para buscar'
      },
    }

    return <QuestionAutocompleteInput key={`${i}-select-cidade`}  {...newProps} />;
  } else  
  if (props?.type === 'bairros') {
    const bairrosFormatted: IQuestionOptions[] = [];
    bairros?.list?.map(({bairro}) => {
      const hasBairro = bairrosFormatted?.find(({value}) => value === bairro);
      if (!hasBairro) {
        bairrosFormatted?.push({value: bairro})
      }
      return bairro;
    });

    const newProps = {
      ...props, 
      options: bairrosFormatted,
      selectProps: {
        disabled: bairros?.loading || bairros?.list?.length === 0,
        onChangeText: (text: string) => {
          const uf = estados?.list?.find(e => e?.nome === getValues()['13'])?.sigla;
          onGetBairros(
            uf as string,
            getValues()['14'],
            text === '' 
              ? 'Rua' 
              : text.replace(/ /g, '+').length < 3 
                ? `Rua ${text.replace(/ /g, '+')}`
                : text.replace(/ /g, '+'));
        },
        placeholder: bairros?.loading 
          ? 'Carregando...' 
          : bairros?.list?.length === 0 
            ? 'Selecione uma cidade primeiro' 
            : 'Selecione ou digite o nome para buscar'
      },
    }

    return <QuestionAutocompleteInput key={`${i}-select-bairro`}  {...newProps} />
  } else  
  if (props?.type === 'string' || props?.type === 'number' || props?.type === 'email') { 
    return <QuestionTextInput {...props} />
  } else 
  if (props?.type === 'select') {
    return <QuestionSelectInput {...props} />
  }else 
  if (props?.type === 'multiselect') {
    return <QuestionMultiselectInput {...props} />
  }
  return <></>
}